module.exports = __webpack_public_path__ + "img/logo_ins.0a3281f3.png";